/**
 * Created by comoon on 8/19/15.
 */
var _ = require("underscore");

function object2class(obj) {
    var array = [];
    _.each(obj, function (val, key) {
        if (val === true) {
            array.push(key);
        } else if (_.isString(val) && val !== '') {
            array.push(val);
        }
    });
    return array.join(" ");
}


function copySizing(source, target, position) {

    var copyItem = function (property) {
        target.css(property, source.css(property));

    };

    copyItem('height');
    copyItem('width');
    copyItem('box-sizing');
    copyItem('margin-top');
    copyItem('margin-right');
    copyItem('margin-bottom');
    copyItem('margin-left');
    copyItem('padding-top');
    copyItem('padding-right');
    copyItem('padding-bottom');
    copyItem('padding-left');
    copyItem('border-top');
    copyItem('border-right');
    copyItem('border-bottom');
    copyItem('border-left');
    //copyItem('z-index');
    copyItem('display');
    copyItem('visibility');
    copyItem('float');
    copyItem('clear');
    copyItem('top');
    copyItem('right');
    copyItem('bottom');
    copyItem('left');
    if (position) {
        copyItem('position');
    }
}

module.exports = {
    object2class,
    copySizing
};


/** WEBPACK FOOTER **
 ** ./script/util/clazz.js
 **/